import { useMemo } from "react";

import type { InteractModuleResourceProperties } from "@skilitics/nautilus-endpoint-definition";

export const useModuleDistributionInfo = <T extends InteractModuleResourceProperties>(module: T | null) => {
  return useMemo(() => {
    const { id, version, title, learningObjective, tags, owner } = module ?? {
      id: "tba",
      version: "tba",
      title: "Waiting for title",
      learningObjective: "",
      tags: [],
      owner: "tba",
    };
    return {
      moduleId: id,
      version,
      title,
      tags,
      owner,
      metadata: {
        learningObjective,
      },
    };
  }, [module]);
};
